<template>
    <form-layout
        ref="dataForm"
        :valid.sync="valid"
        :mode="mode"
        :form-title="schema.titleSingular"
        :hide-title="hideTitle"
        :hide-delete="hideDelete"
        :hide-cancel="hideCancel"
        :is-edit="isEdit"
        :is-saving="isSaving"
        :is-readonly="isReadonly"
        @save="save"
        @cancel="cancel()"
        @deleteItem="deleteItem()">
        <template v-slot:content="">
            <template v-for="field in filteredFields">
                <component
                    :is="field.component"
                    v-if="!isFiltered(field.camelSingular)"
                    :key="field.value"
                    v-model="item[field.camelSingular]"
                    :field="field"
                    :filter="filter"
                    :custom-filter="getCustomFilter(field)"
                    :is-edit="isEdit"
                    :is-readonly="isReadonly"
                    :is-dense="isDense"
                    :is-disabled="isDisabled"
                    :is-saving="isSaving"
                    :schema="schema"
                    :item="item"
                    @save="save" />
            </template>
        </template>
    </form-layout>
</template>

<script>
import { greaterThan, or, equal } from "@/services/filtering"
import formMixin from "@/mixins/formMixin"
import dateUtility from "@/services/dateUtility"

export default {
    mixins: [formMixin],
    methods: {
        getCustomFilter(field) {
            if (field.camelSingular === "labTestId") {
                let filters = [
                    greaterThan("SuspendedOn", dateUtility.getCurrentDateIso(), "datetimeoffset"),
                    equal("SuspendedOn", null, "datetimeoffset?")
                ];
                return or(filters);
            }
            return null;
        }
    }
};
</script>
